import * as TYPES from './type';
export default {
  //授课签到
  [TYPES.SK_SIGIN_ADD](state, { result }) {
    state.SKSignAdd = result.result
  },
  [TYPES.SK_SIGIN_STU_LIST](state, { result }) {
    state.SKSignStuList = result.result
  },
  [TYPES.SK_SIGIN_LIST](state, { result }) {
    state.SKSignList = result.result
  },
  [TYPES.SK_SIGIN_ON](state, { result }) {
    state.SKSignOn = result.result
  },
  [TYPES.SK_SIGIN_DETAIL](state, { result }) {
    state.SKSignDetail = result.result
  },
  [TYPES.SK_SIGIN_EDIT](state, { result }) {
    state.SKSignEdit = result.result
  },
  [TYPES.SK_SIGIN_STU_EDIT](state, { result }) {
    state.SKSignStuEdit = result.result
  },
  [TYPES.SK_SIGIN_STU_BATCH_EDIT](state, { result }) {
    state.SKSignStuBatchEdit = result.result
  },
}